import { render, staticRenderFns } from "./SocialContacts.vue?vue&type=template&id=44bdffce&scoped=true&"
import script from "./SocialContacts.vue?vue&type=script&lang=js&"
export * from "./SocialContacts.vue?vue&type=script&lang=js&"
import style0 from "./SocialContacts.vue?vue&type=style&index=0&id=44bdffce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdffce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
